import './navigation'
import './google-translate'
import './prompt-down'
import './contact-popup'
import './community-resources-categories'
import './category-navigation'
import './hand-button'
import './services-maps'
import './print-list'

window.addEventListener('DOMContentLoaded', () => {
	// AOS
	AOS.init({
		duration: 400,
		delay: 50,
		once: true,
	})
})
